















import {Component, Prop, Watch} from 'vue-property-decorator'
import NotificationList from './components/NotificationsList.vue';
import {NotificationDataHelper} from "./helpers/NotificationDataHelper";
import {EventBus} from "@common/EventBus";
import AnalyticsMixin from "../../mixins/AnalyticsMixin";
import PocketBlock from "../../share/common/pocket/Pocket.vue";

import Overlay from "@share/common/Overlay.vue";
import BounceSpinner from "@share/common/BounceSpinner.vue";

@Component({
    components: { NotificationList, PocketBlock, Overlay, BounceSpinner }
})
export default class NotificationsListWrapper extends AnalyticsMixin {

    @Prop({ default: false }) showList: boolean;
    @Prop({required: true}) dataHelper: NotificationDataHelper;

    close() {
        this.sendScreenView(this.$store.state.screenNameData?.prevName || this.$route.meta?.analyticName);
        this.$emit('close');
    }

    @Watch('showList')
    async toggleList(value: boolean) {

        if (value) {
            await this.dataHelper?.loadList();
        }

        if (value) {
            this.sendScreenView('Notifications');
        }
        else {
            this.sendScreenView(this.$store.state.screenNameData?.prevName || this.$route.meta?.analyticName);
        }
    }

    beforeDestroy() {
        EventBus.$off('notification-opened');
    }

    get profiles() {
        return this.dataHelper?.profiles;
    }

    get updates() {
        return this.dataHelper?.updates || {};
    }
}
